import { useState, useContext, useEffect } from "react";
import { CompanyContext } from "../../../contexts/company-context";
import { AuthenticationContext } from "../../../contexts/authentication-context";
import { ScheduleOperation } from "../../../serviceoperation/ScheduleOperation";
import { ScheduleReportQuery } from "../../../serviceoperation/entity/ScheduleOperationEntity";
import { ScheduleHistory } from "../types";

export const useReportData = (
  deFaultPageSize: number,
  reFetchSchedule: boolean
) => {
  const { selectedCompany } = useContext(CompanyContext);
  const userInfo = useContext(AuthenticationContext)?.userInfo;
  const [history, setHistory] = useState<ScheduleHistory[]>([]);
  const [queryOptions, setQueryOptions] = useState<ScheduleReportQuery>();
  const [totalResult, setTotalResult] = useState<number>(0);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const scheduleOps = new ScheduleOperation();

  const getFormattedDateTime = (dateTimeString?: string) => {
    if (dateTimeString) {
      return `${new Date(dateTimeString + "Z").toLocaleString()}`;
    }
    return "";
  };

  const fetchScheduleReport = async (options: ScheduleReportQuery) => {
    return await scheduleOps.getScheduleReportAsync(
      selectedCompany?.corporationId as number,
      options
    );
  };

  const fetchScheduleReportData = async (options: ScheduleReportQuery) => {
    setIsLoading(true);
    const response = await fetchScheduleReport(options);
    setTotalResult(response.data.rowCount);
    setIsLoading(false);
    return response?.data?.results?.map((result) => ({
      employee: result.employee,
      scheduleId: result.scheduleId,
      title: result.title,
      note: result.note,
      scheduleDate: result.scheduleDate,
      startTime: getFormattedDateTime(result.employeeActivity?.clockedInAt),
      endTime: getFormattedDateTime(result.employeeActivity?.clockedOutAt),
      requireSync: result.requireSync,
      syncStatus: result.syncStatus,
      isAbsent: result.isAbsent,
      absentReason: result.absentReason,
      employeeActivity: result.employeeActivity,
    }));
  };

  useEffect(() => {
    const options: ScheduleReportQuery = {
      weekOf: new Date().toDateString(),
      page: 1,
      pageSize: deFaultPageSize,
      IncludeDirReport: true,
    };
    const newOptions = queryOptions ?? options;
    setQueryOptions(newOptions);
    fetchScheduleReportData(newOptions).then(setHistory);
  }, [selectedCompany, userInfo, reFetchSchedule]);

  return {
    history,
    setHistory,
    queryOptions,
    setQueryOptions,
    totalResult,
    isLoading,
    fetchScheduleReportData,
  };
};
